export default __webpack_public_path__ + "static/img4-8d64fd2e24238a60a48662275d9f2065.png";